<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-4 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center w-full gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-filter text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.SEGMENT.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.SEGMENT.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview Tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-4 overflow-auto h-full">
      <div class="flex flex-column gap-4">
         <span class="font-semibold text-900">Segmento seleccionado</span>

         <div *ngIf="selectedSegment(); else emptyPreview" class="flex flex-column gap-3">
            <div class="surface-card border-1 border-round-xl border-blue-100 overflow-hidden shadow-1">
               <div class="p-4 bg-blue-50 border-bottom-1 border-blue-100 flex flex-row gap-4 align-items-center">
                  <div
                     class="bg-white border-round-xl flex align-items-center justify-content-center w-3rem h-3rem shadow-sm"
                  >
                     <i class="pi pi-filter text-blue-700 text-lg"></i>
                  </div>

                  <div class="flex flex-column gap-1">
                     <span class="font-medium text-500 text-xs uppercase tracking-wider">{{
                        'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.TITLE' | translate
                     }}</span>
                     <span class="text-blue-900 font-bold text-xl">
                        {{ selectedSegment()?.name }}
                     </span>

                     <div class="flex align-items-center gap-2 mt-1">
                        <span
                           *ngIf="selectedSegment()?.default"
                           class="text-xs px-2 py-0.5 border-round-md bg-orange-50 text-orange-700 border-1 border-orange-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-star-fill" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_DEFAULT' | translate }}
                        </span>
                        <span
                           *ngIf="selectedSegment()?.isInUse"
                           class="text-xs px-2 py-0.5 border-round-md bg-teal-50 text-teal-700 border-1 border-teal-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-check-circle" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_IN_USE' | translate }}
                        </span>
                        <span
                           *ngIf="selectedSegment()?.filters?.length"
                           class="text-xs px-2 py-0.5 border-round-md bg-bluegray-50 text-bluegray-600 border-1 border-bluegray-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-list" style="font-size: 0.65rem"></i>
                           {{ selectedSegment()?.filters?.length }}
                        </span>
                     </div>
                  </div>
               </div>

               <div class="p-4 bg-white">
                  <div class="flex flex-column gap-3">
                     <div class="flex align-items-center gap-2">
                        <i class="pi pi-list text-blue-400"></i>
                        <span class="font-semibold text-900">{{
                           'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.FILTERS_TITLE' | translate
                        }}</span>
                     </div>

                     <div class="flex flex-column gap-2">
                        <ng-container *ngIf="selectedSegment()?.filters?.length; else noFilters">
                           <div
                              *ngFor="let filter of selectedSegment()?.filters; let first = first"
                              class="flex flex-column gap-1"
                           >
                              <div class="p-3 border-round-lg bg-bluegray-50 border-1 border-bluegray-100">
                                 <div class="flex flex-row gap-2 align-items-start w-full">
                                    <div *ngIf="!first" class="mt-1">
                                       <span
                                          class="text-[10px] font-semibold px-2 py-1 border-round bg-blue-500 text-white uppercase"
                                       >
                                          {{ 'DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL.CONDITIONAL' | translate }}
                                       </span>
                                    </div>
                                    <div class="text-sm line-height-3 text-700 flex-grow-1">
                                       {{ getFilterText(filter) }}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </ng-container>
                        <ng-template #noFilters>
                           <p-messages severity="info" [closable]="false" styleClass="m-0">
                              <ng-template pTemplate>
                                 <span class="text-sm">{{
                                    'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.NO_FILTERS' | translate
                                 }}</span>
                              </ng-template>
                           </p-messages>
                        </ng-template>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <ng-template #emptyPreview>
            <div class="flex flex-column align-items-center justify-content-center py-8 text-400 opacity-60">
               <i class="pi pi-filter text-5xl mb-3"></i>
               <span>{{ 'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.EMPTY' | translate }}</span>
            </div>
         </ng-template>

         <div *ngIf="errors().length" class="mt-2">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">
               {{ e.errorMessage }}
            </div>
         </div>
      </div>
   </div>

   <!-- Config Tab -->
   <div *ngIf="activeTab() === 'config'" class="p-4 overflow-auto h-full">
      <div class="flex flex-column gap-4">
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-1">
               <span class="font-semibold text-900">{{ 'DATA.MODULES.INSPECTORS.SEGMENT.TITLE' | translate }}</span>
               <span class="text-sm text-500">{{ 'DATA.MODULES.INSPECTORS.SEGMENT.DESCRIPTION' | translate }}</span>
            </div>

            <div class="flex flex-column gap-2">
               <p-dropdown
                  [options]="segments()"
                  [(ngModel)]="selectedSegmentId"
                  optionLabel="name"
                  optionValue="id"
                  [placeholder]="'DATA.MODULES.INSPECTORS.SEGMENT.CONFIG.SEGMENT_PLACEHOLDER' | translate"
                  [showClear]="true"
                  styleClass="w-full"
                  (onChange)="onSelectSegment($event)"
               >
                  <ng-template let-option pTemplate="item">
                     <div *ngIf="option" class="flex align-items-center gap-2">
                        <i class="pi pi-filter text-blue-600"></i>
                        <span>{{ option.name }}</span>
                        <span
                           *ngIf="option.default"
                           class="text-xs px-2 py-0.5 border-round-md bg-orange-50 text-orange-700 border-1 border-orange-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-star-fill" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_DEFAULT' | translate }}
                        </span>
                        <span
                           *ngIf="option.isInUse"
                           class="text-xs px-2 py-0.5 border-round-md bg-teal-50 text-teal-700 border-1 border-teal-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-check-circle" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_IN_USE' | translate }}
                        </span>
                     </div>
                  </ng-template>
               </p-dropdown>

                <div *ngIf="editSegmentUrl()" class="flex justify-content-end mt-1">
                    <a
                        [href]="editSegmentUrl()"
                        target="_blank"
                        class="text-xs text-blue-600 hover:text-blue-800 font-medium no-underline flex align-items-center gap-1"
                    >
                        <i class="pi pi-external-link"></i>
                       Editar segmento seleccionado
                    </a>
                </div>
            </div>
         </div>

         <!-- Filters Display when segment is selected -->
         <div *ngIf="selectedSegment()" class="flex flex-column gap-3">
            <div class="surface-card border-1 border-round-xl border-blue-100 overflow-hidden shadow-1">
               <div class="p-4 bg-blue-50 border-bottom-1 border-blue-100 flex flex-row gap-4 align-items-center">
                  <div
                     class="bg-white border-round-xl flex align-items-center justify-content-center w-3rem h-3rem shadow-sm"
                  >
                     <i class="pi pi-filter text-blue-700 text-lg"></i>
                  </div>

                  <div class="flex flex-column gap-1">
                     <span class="font-medium text-500 text-xs uppercase tracking-wider">{{
                        'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.TITLE' | translate
                     }}</span>
                     <span class="text-blue-900 font-bold text-xl">
                        {{ selectedSegment()?.name }}
                     </span>

                     <div class="flex align-items-center gap-2 mt-1">
                        <span
                           *ngIf="selectedSegment()?.default"
                           class="text-xs px-2 py-0.5 border-round-md bg-orange-50 text-orange-700 border-1 border-orange-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-star-fill" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_DEFAULT' | translate }}
                        </span>
                        <span
                           *ngIf="selectedSegment()?.isInUse"
                           class="text-xs px-2 py-0.5 border-round-md bg-teal-50 text-teal-700 border-1 border-teal-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-check-circle" style="font-size: 0.65rem"></i>
                           {{ 'DATA.MODULES.INSPECTORS.SEGMENT.BADGE_IN_USE' | translate }}
                        </span>
                        <span
                           *ngIf="selectedSegment()?.filters?.length"
                           class="text-xs px-2 py-0.5 border-round-md bg-bluegray-50 text-bluegray-600 border-1 border-bluegray-100 flex align-items-center gap-1"
                        >
                           <i class="pi pi-list" style="font-size: 0.65rem"></i>
                           {{ selectedSegment()?.filters?.length }}
                        </span>
                     </div>
                  </div>
               </div>

               <div class="p-4 bg-white">
                  <div class="flex flex-column gap-3">
                     <div class="flex align-items-center gap-2">
                        <i class="pi pi-list text-blue-400"></i>
                        <span class="font-semibold text-900">{{
                           'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.FILTERS_TITLE' | translate
                        }}</span>
                     </div>

                     <div class="flex flex-column gap-2">
                        <ng-container *ngIf="selectedSegment()?.filters?.length; else noFilters">
                           <div
                              *ngFor="let filter of selectedSegment()?.filters; let first = first"
                              class="flex flex-column gap-1"
                           >
                              <div class="p-3 border-round-lg bg-bluegray-50 border-1 border-bluegray-100">
                                 <div class="flex flex-row gap-2 align-items-start w-full">
                                    <div *ngIf="!first" class="mt-1">
                                       <span
                                          class="text-[10px] font-semibold px-2 py-1 border-round bg-blue-500 text-white uppercase"
                                       >
                                          {{ 'DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL.CONDITIONAL' | translate }}
                                       </span>
                                    </div>
                                    <div class="text-sm line-height-3 text-700 flex-grow-1">
                                       {{ getFilterText(filter) }}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </ng-container>
                        <ng-template #noFilters>
                           <p-messages severity="info" [closable]="false" styleClass="m-0">
                              <ng-template pTemplate>
                                 <span class="text-sm">{{
                                    'DATA.MODULES.INSPECTORS.SEGMENT.PREVIEW.NO_FILTERS' | translate
                                 }}</span>
                              </ng-template>
                           </p-messages>
                        </ng-template>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div *ngIf="errors().length" class="mt-2">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">
               {{ e.errorMessage }}
            </div>
         </div>
      </div>
   </div>
</div>
